import {computed, ref, Component} from "vue";

export enum AlertDialogType {
    CONFIRMATION = "CONFIRMATION",
    INFORMATION = "INFORMATION",
    SUCCESS = "SUCCESS",
    WARNING = "WARNING",
    DESTRUCTIVE = "DESTRUCTIVE",
    ERROR = "ERROR",
}

type AlertDialogCallback = () => Promise<void>;

interface AlertDialogProps {
    title: string;
    description: string;
    confirmLabel?: string;
    cancelLabel?: string;
    props?: object,
    component?: Component,
    type?: AlertDialogType;
    onConfirm?: AlertDialogCallback;
    onCancel?: AlertDialogCallback;
}

interface State {
    alertDialog: AlertDialogProps | null;
    visible: boolean;
    resolveAction?: (value: boolean | PromiseLike<boolean>) => void; // Now nullable
    rejectAction?: (reason?: any) => void; // Now nullable
}

const emptyState = {
    alertDialog: null,
    visible: false
}

const defaultAlertDialog = {
    confirmLabel: "Close",
    type: AlertDialogType.INFORMATION
} as AlertDialogProps

const state = ref<State>(emptyState);

function useAlertDialog() {
    function alertDialog(alertDialog: AlertDialogProps): Promise<boolean> {
        state.value = emptyState
        return new Promise<boolean>(
            (resolve, reject) => {
            state.value.alertDialog = {...defaultAlertDialog, ...alertDialog};
            state.value.visible = true;
            state.value.resolveAction = resolve;
            state.value.rejectAction = reject;
        });
    }

    function closeAlertDialog() {
        state.value.visible = false;
    }

    const onCancel = async () => {
        try {
            if (state.value.alertDialog?.onCancel != null) {
                await state.value.alertDialog?.onCancel?.();
                state.value.rejectAction?.(true)
            }
            closeAlertDialog();
        } catch (error) {
            console.log("her gepasseerd")
            state.value.rejectAction?.(error)
        }
    };

    const onConfirm = async () => {
        try {
            closeAlertDialog();
            await state.value.alertDialog?.onConfirm?.();
            state.value.resolveAction?.(true)
        } catch (error) {
            state.value.rejectAction?.(error)
        }
    };

    return {
        _alertDialog: computed(() => state.value.alertDialog),
        _visible:  computed(() => state.value.visible),
        alertDialog,
        closeAlertDialog,
        onConfirm,
        onCancel,
    };
}

export {useAlertDialog}




